import { render } from "./BanTheHienLenh.vue?vue&type=template&id=1ff6e6ec"
import script from "./BanTheHienLenh.vue?vue&type=script&lang=js"
export * from "./BanTheHienLenh.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__